export const statuses = {
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  PAID: 'PAID',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  PAID_OUT: 'PAID_OUT',
};

// Wire value: must match the API's SUPPORT_CANCELLATION_REASON, which is both
// the reason a back-office cancellation writes and the actor the timeline shows.
export const SUPPORT_CANCELLATION_NAME = 'Stugknuten support';
